<ng-container *transloco="let t; scope: 'uiComponents'">
  <div class="flex bd-filepath">
    @if (breadcrumbItems().length) {
      <bd-breadcrumb
        class="self-center"
        [breadcrumbItems]="breadcrumbItems()"
      />
    }
    @if (chevronVisible()) {
      <p-button
        data-id="filepath-chevron"
        class="self-center"
        [text]="true"
        [disabled]="chevronDisabled()"
        [attr.aria-expanded]="popoverOpen()"
        icon="{{
          popoverOpen()
            ? 'ui-up bd-button-chevron'
            : 'ui-down bd-button-chevron'
        }}"
        [ariaLabel]="
          chevronAriaLabel() ?? t('uiComponents.navigation.filePathButtonInfo')
        "
        [pTooltip]="chevronTooltip() ?? ''"
        [tooltipDisabled]="popoverOpen() || !chevronTooltip()"
        tooltipPosition="bottom"
        [showDelay]="500"
        styleClass="{{
          isLastToolbarItem() ? 'bd-round-right' : ''
        }} bd-toolbar-button-small"
        (onClick)="popover.toggle($event, $event.currentTarget)"
      />
      <p-popover
        #popover
        appendTo="body"
        styleClass="bd-searchable-menu-popover bd-popover-rounded"
        (onShow)="popoverOpen.set(true)"
        (onHide)="popoverOpen.set(false)"
      >
        <ng-content />
      </p-popover>
    }
  </div>
</ng-container>
